import Sentry from './Sentry';

// TODO: https://welltech.atlassian.net/browse/UPP-90
const tracesSampleRate = process.env.ENV === 'prod' ? 0.05 : 1;

export default new Sentry({
  sentryDSN: import.meta.env.SENTRY_DSN,
  env: import.meta.env.ENV,
  release: `${import.meta.env.AWS_DELIVERY_STREAM_NAME}_${import.meta.env.ENV}_${import.meta.env.RELEASE_DATE}`,
  tracesSampleRate,
  autoSessionTracking: true,
});
